import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetTenDlcActionLogs,
  type IParamsGetTenDlcStatusLogs,
  type IResponseTenDlcActionLog,
  type IResponseTenDlcBanner,
  type IResponseTenDlcLimits,
  type IResponseTenDlcStatusLog,
  type IResponseTenDlcUseCases,
} from 'entities/TenDlc/api/type'

class Api {
  getTenDlcLimits(): Promise<AxiosResponse<IResponseTenDlcLimits>> {
    return baseApi.get('organization/10-dlc/limits')
  }

  getTenDlcUseCases(): Promise<AxiosResponse<IResponseTenDlcUseCases[]>> {
    return baseApi.get('compliance/enum/use-cases')
  }

  updateTenDlcBanner(): Promise<AxiosResponse<IResponseTenDlcBanner>> {
    return baseApi.post('users/dlc-banner-showed', { banner_showed: true })
  }

  getTenDlcActionLogs(
    params: IParamsGetTenDlcActionLogs
  ): Promise<AxiosResponse<IResponseTenDlcActionLog>> {
    return baseApi.post('compliance/services/audit-logs', params)
  }

  getTenDlcStatusLogs(
    params: IParamsGetTenDlcStatusLogs
  ): Promise<AxiosResponse<IResponseTenDlcStatusLog>> {
    return baseApi.post('compliance/services/status-history', params)
  }
}

export const TenDlcApi = new Api()
